import { ExternalLink } from 'lucide-react';
import Chip from '../Chip';
import { BudgetItemDocument } from '../../types/budget';

interface BudgetDocumentsListProps {
  documents: BudgetItemDocument[];
}

const docTypeVariant = (docType: string): 'info' | 'success' | 'warning' | 'neutral' => {
  const t = docType.toLowerCase();
  if (t.includes('schedule') || t.includes('s13')) return 'info';
  if (t.includes('governor') || t.includes('executive')) return 'success';
  if (t.includes('briefing') || t.includes('jbc')) return 'warning';
  return 'neutral';
};

const BudgetDocumentsList: React.FC<BudgetDocumentsListProps> = ({ documents }) => {
  if (documents.length === 0) {
    return (
      <div className="text-center py-8 text-text-tertiary dark:text-text-dark-tertiary text-sm">
        No documents available.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {documents.map((doc) => (
        <a
          key={doc.id}
          href={doc.doc_url}
          target="_blank"
          rel="noopener noreferrer"
          className="card p-4 flex items-start justify-between gap-3 hover:shadow-md transition-shadow group"
        >
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <Chip label={doc.doc_type} variant={docTypeVariant(doc.doc_type)} size="sm" />
              {doc.is_primary_source && (
                <Chip label="Primary Source" variant="success" size="sm" />
              )}
            </div>
            <h4 className="text-sm font-medium text-text-primary dark:text-text-dark-primary group-hover:text-primary-600 dark:group-hover:text-primary-400 truncate">
              {doc.doc_title}
            </h4>
            <div className="flex items-center gap-3 mt-1 text-xs text-text-tertiary dark:text-text-dark-tertiary">
              {doc.published_date && (
                <span>{new Date(doc.published_date).toLocaleDateString()}</span>
              )}
              {doc.source && <span>{doc.source}</span>}
            </div>
          </div>
          <ExternalLink className="w-4 h-4 text-text-tertiary dark:text-text-dark-tertiary group-hover:text-primary-600 dark:group-hover:text-primary-400 flex-shrink-0 mt-1" />
        </a>
      ))}
    </div>
  );
};

export default BudgetDocumentsList;
